import { INVESTIGATION_HISTORY_PANEL_STICKY_HEADER_OVERLAY_HEIGHT_PX } from "#src/routes/investigations/history/consts";
import type { InvestigationHistoryListRowType } from "#src/routes/investigations/history/groupInvestigationsByRecency";

type IsInvestigationHistoryRowVisibleInScrollportArgs = {
  scrollTop: number;
  viewportHeight: number;
  rowOffset: number;
  rowSize: number;
  stickyHeaderOverlayHeightPx?: number;
};

/**
 * Returns the scroll offset that places a row below the sticky recency header.
 */
export const getInvestigationHistoryListScrollTopForRowOffset = (
  rowOffset: number,
  stickyHeaderOverlayHeightPx: number = INVESTIGATION_HISTORY_PANEL_STICKY_HEADER_OVERLAY_HEIGHT_PX
): number => Math.max(0, rowOffset - stickyHeaderOverlayHeightPx);

/**
 * Returns whether a virtualized row is visible in the scrollport and not covered
 * by the sticky recency header.
 */
export const isInvestigationHistoryRowVisibleInScrollport = ({
  scrollTop,
  viewportHeight,
  rowOffset,
  rowSize,
  stickyHeaderOverlayHeightPx = INVESTIGATION_HISTORY_PANEL_STICKY_HEADER_OVERLAY_HEIGHT_PX,
}: IsInvestigationHistoryRowVisibleInScrollportArgs): boolean => {
  const visibleViewportStart = scrollTop + stickyHeaderOverlayHeightPx;
  const viewportEnd = scrollTop + viewportHeight;
  const rowEnd = rowOffset + rowSize;

  return (
    rowOffset >= visibleViewportStart &&
    rowEnd > visibleViewportStart &&
    rowOffset < viewportEnd
  );
};

/**
 * Finds the virtualized list row index for a selected investigation id.
 */
export const getSelectedInvestigationHistoryRowIndex = (
  listRows: InvestigationHistoryListRowType[],
  selectedInvestigationId?: string
): number => {
  if (!selectedInvestigationId) {
    return -1;
  }

  return listRows.findIndex(
    (row) =>
      row.type === "item" && row.investigation.id === selectedInvestigationId
  );
};
